import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CompletedQuantityChartPage } from "src/components/views/erp/production/reports/completedQuantityChart/CompletedQuantityChartPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/production/completedQuantity")({
	staticData: { title: i18n.t("completed_quantity"), legacyViewKey: "completedQuantityChartPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CompletedQuantityChartPage />;
}
